import React from "react"
import { Box } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: 4
  },
  divider: {
    background: theme.palette.grey[300],
    height: "100%",
    width: 1.5
  }
}))

export default function FormElementVerticalSeparator() {
  const classes = useStyles()
  return (
    <Box
      className={classes.root}
      height="100%"
      display="flex"
      justifyContent="center"
    >
      <div className={classes.divider} />
    </Box>
  )
}
